import { cn } from '@/lib/utils';
import Flex from './Flex';

type DivProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>;

function Container({ className, ...props }: DivProps) {
  return <div className={cn('container pb-5', className)} {...props}></div>;
}

function Heading({className, ...props}: DivProps) {
  return <Flex.Col gap="2" className={cn('my-5 py-2', className)} {...props}></Flex.Col>;
}

function Body({ className, ...props }: DivProps) {
  return (
    <Flex.Col className={cn('gap-5 w-full', className)} {...props}></Flex.Col>
  );
}

function Title({ className, ...props }: DivProps) {
  return <h1 className={cn('text-2xl font-semibold', className)} {...props}></h1>;
}

function Description({ className, ...props }: DivProps) {
  return <div className={cn('text-sm text-secondary', className)} {...props}></div>;
}

const Page = {
  Container,
  Heading,
  Body,
  Title,
  Description,
};

export default Page;
